import { render, staticRenderFns } from "./userMenu.vue?vue&type=template&id=656768a7"
import script from "./userMenu.vue?vue&type=script&lang=js"
export * from "./userMenu.vue?vue&type=script&lang=js"
import style0 from "./userMenu.vue?vue&type=style&index=0&id=656768a7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports